export const DBConstants = {
    DB_FETCHING: 'DB_FETCHING',
    DB_FETCHED: 'DB_FETCHED',
    GET_DB: 'GET_DB',
}